import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatItinerarioInformativo'
})
export class FormatItinerarioInformativoPipe implements PipeTransform {

  transform(value: string): unknown {
    if (!value) {
      return '';
    }

    value += '\n';

    const formattedText = value
      .replace(/\n\n/g, '<br><p>') // Duas quebras de linha viram <br> + <p>
      .replace(/\n/g, '</p><p>') // Quebra de linha vira fechamento e abertura de <p>
      .replace(/_([^_]+)_/g, '<span class="italico">$1</span>') // Itálico
      .replace(/\*\*([^*]+)\*\*/g, '<span class="negrito">$1</span>') // Negrito
      .replace(/\[(.*?)\]\((.*?)\)/g, '<a class="link custom-link" target="_blank" rel="noreferrer" href="$2">$1</a>'); // Links

    return `<p>${formattedText}</p>`;
  }
}
